import Api from "../api";

export default async function apiDeleteMapSector(id: string) {
  return await Api.delete<string>({
    input: `/api/v1/map-sector/${id}`,
  });
}
